import { createRouter, createWebHistory } from 'vue-router'
import AdminLayout from '../components/AdminLayout.vue'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    // Frontend routes
    {
      path: '/',
      name: 'home',
      component: () => import('../pages/HomePage.vue'),
    },
    {
      path: '/products',
      name: 'products',
      component: () => import('../pages/ProductsPage.vue'),
    },
    {
      path: '/product-list',
      name: 'productList',
      component: () => import('../pages/ProductListPage.vue'),
    },
    {
      path: '/product/:id',
      name: 'productDetail',
      component: () => import('../pages/ProductDetailPage.vue'),
    },
    {
      path: '/cases',
      name: 'cases',
      component: () => import('../pages/CasesPage.vue'),
    },
    {
      path: '/case/:id',
      name: 'caseDetail',
      component: () => import('../pages/CaseDetailPage.vue'),
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('../pages/AboutPage.vue'),
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('../pages/ContactPage.vue'),
    },
    {
      path: '/privacy-policy',
      name: 'privacyPolicy',
      component: () => import('../pages/PrivacyPolicyPage.vue'),
    },
    {
      path: '/cookie-notice',
      name: 'cookieNotice',
      component: () => import('../pages/CookieNoticePage.vue'),
    },
    {
      path: '/news',
      name: 'news',
      component: () => import('../pages/NewsPage.vue'),
    },
    {
      path: '/news/:id',
      name: 'newsDetail',
      component: () => import('../pages/NewsDetailPage.vue'),
    },

    // Admin routes
    {
      path: '/admin/login',
      name: 'adminLogin',
      component: () => import('../pages/admin/LoginPage.vue'),
    },
    {
      path: '/admin',
      component: AdminLayout,
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          redirect: '/admin/dashboard',
        },
        {
          path: 'dashboard',
          name: 'adminDashboard',
          component: () => import('../pages/admin/DashboardPage.vue'),
        },
        {
          path: 'products',
          name: 'adminProducts',
          component: () => import('../pages/admin/ProductManagePage.vue'),
        },
        {
          path: 'news',
          name: 'adminNews',
          component: () => import('../pages/admin/NewsManagePage.vue'),
        },
        {
          path: 'cases',
          name: 'adminCases',
          component: () => import('../pages/admin/CaseManagePage.vue'),
        },
        {
          path: 'contacts',
          name: 'adminContacts',
          component: () => import('../pages/admin/ContactManagePage.vue'),
        },
        {
          path: 'settings',
          name: 'adminSettings',
          component: () => import('../pages/admin/SettingManagePage.vue'),
        },
      ],
    },
  ],
  scrollBehavior() {
    return { top: 0 }
  },
})

// Navigation guard for admin routes
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const adminUser = localStorage.getItem('adminUser')
    if (!adminUser) {
      next('/admin/login')
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
